export function formatDuration(ms: number) {
  if (!Number.isFinite(ms) || ms <= 0) return '0 dtk';
  const totalSeconds = Math.round(ms / 1000);
  if (totalSeconds < 60) return `${totalSeconds} dtk`;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes} m ${String(seconds).padStart(2, '0')} dtk`;
}

export function formatClock(iso?: string) {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(new Date(iso));
}
